import { render, staticRenderFns } from "./secure_route.vue?vue&type=template&id=5df04482&scoped=true"
import script from "./secure_route.vue?vue&type=script&lang=js"
export * from "./secure_route.vue?vue&type=script&lang=js"
import style0 from "./secure_route.vue?vue&type=style&index=0&id=5df04482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df04482",
  null
  
)

export default component.exports